import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import Footer from "./Footer";
import styled from "styled-components"
import danielle1 from "../src/images/danielle1.png"
import danielle2 from "../src/images/danielle2.png"
import annie1 from "../src/images/annie1.png"
import annie2 from "../src/images/annie2.png"
import celine1 from "../src/images/celine1.png"
import celine2 from "../src/images/celine2.png"
import christine1 from "../src/images/christine1.png"


const Coach = () => {
    const [reps, setReps] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const navigate = useNavigate();
    const { t , i18n } = useTranslation();
    useEffect(() => {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }, []);

    const images = {
        annie1: annie1,
        annie2: annie2,
        danielle1: danielle1,
        danielle2: danielle2,
        celine1: celine1,
        celine2: celine2,
        christine1: christine1,
        christine2: christine1
      };
  
    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
      
        fetch(`${API_URL}reps`)
          .then((res) => res.json())
          .then((data) => {
            const coachOrder = ["Danielle", "Céline", "Christine", "Annie"];
             const sortedReps = data.sort(
      (a, b) => coachOrder.indexOf(a.firstName) - coachOrder.indexOf(b.firstName)
    );
            setReps(sortedReps);
          })
          .catch((error) => {
            console.error("Error fetching reps!", error);
          });
      }, []);

      useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? 1 : 0));
        }, 10000); // switch every 10 seconds
        return () => clearInterval(interval);
      }, []);
  
    return (
      <div>
        <Header />
        <Content>
          <Title>{t("coaches.ourCoaches")}</Title>
          <CoachGrid>
          {reps
          .filter(rep => rep.firstName !== "Véronique")
          .map((rep, index) => (
  <CoachCard key={rep._id} $reverse={index % 2 !== 0}>
    <CoachImagesWrapper $reverse={index % 2 !== 0}>
      <CoachImage src={images[rep.image]} alt={rep.firstName} $isVisible={currentImageIndex === 0} />
      <CoachImage src={images[rep.image2]} alt={rep.firstName} $isVisible={currentImageIndex === 1} />
    </CoachImagesWrapper>
    <CoachInfo $reverse={index % 2 !== 0}>
      <Meet>{t("coaches.meet")}</Meet>
      <CoachName>{rep.firstName} {rep.lastName}</CoachName>
      <CoachTitle>{rep.title[i18n.language]}</CoachTitle>
      <CoachDescription>{rep.description[i18n.language]}</CoachDescription>
      <CoachDescription>{rep.description2[i18n.language]}</CoachDescription>
      <CoachSpan><Iam>{t("coaches.im")} {rep.firstName}</Iam></CoachSpan>
      <Button onClick={() => navigate(`/consultation?coach=${encodeURIComponent(rep.firstName + " " + rep.lastName)}`)}>
        {t("coaches.takeConsultation", { coach: rep.firstName })}
      </Button>
    </CoachInfo>
  </CoachCard>
))}
          </CoachGrid>
        </Content>
        <Footer />
      </div>
    );
  };
  
  export default Coach;

const Content = styled.div`
  background:linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);
  padding: 40px 20px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  min-height: 100vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 1900px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Title = styled.h1`
  text-align: center;
  font-size: 60px;
  margin-bottom: 50px;
  color: #fff;
  letter-spacing: 2px;
`;

const CoachGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin: 0 auto;
`;

const CoachCard = styled.div`
  display: flex;
  flex-direction: ${({ $reverse }) => ($reverse ? 'row-reverse' : 'row')};
  align-items: center;
  gap: 5%;
  width: 90%;
  margin: 0 auto;
  flex-wrap: wrap;

  @media (max-width: 1000px) {
    flex-direction: column;
    text-align: center;
  }
`;

const CoachImagesWrapper = styled.div`
  position: relative;
  flex: 1 1 300px;
  min-width: 250px;
  max-width: 400px;
  aspect-ratio: 1 / 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`;


const CoachImage = styled.img`
  position: absolute;
  width: 100%;
  max-width: 400px;
  height: 400px;
  object-fit: cover;
  border-radius: 20px;
  box-shadow: 0 1px 40px white;
  transition: opacity 3s ease-in-out;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
`;
const CoachInfo = styled.div`
  flex: 2 1 400px;
  padding: 50px;
  text-align: center;
`;

const CoachName = styled.h2`
  font-size: 80px;
  margin-bottom: 10px;
  color: white;
  font-family: "Great Vibes";
`;

const CoachDescription = styled.p`
  font-size: 20px;
  color: black;
  line-height: 1.6;
`;
const CoachSpan = styled.span`
  font-size: 20px;
  color: black;
  line-height: 1.6;
`

const Meet = styled.p`
font-size: 20px;
margin-bottom: -50px;
color: white;
font-style: italic
`

const CoachTitle = styled.p`
margin-top: -15px;
color: rgba(217,121,97,1);
font-weight: bold;
`

const Button = styled.button`
padding: 10px;
background-color: rgba(217,121,97,1);
color: white;
border: none;
box-shadow: 0 4px 24px white;
font-size: 18px;
border-radius: 10px;
margin-bottom: 50px;
cursor: pointer;
`
const Iam = styled.p`
font-style: italic;
`